
import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Numeral from 'numeral'
import { getTimezoneDate } from 'utils/date'

import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'

import { dirtyRead, doc } from 'selectors/common'
import { properties, tenants } from 'selectors/entities'
import { transactionEx } from 'selectors/transactions'

import {getMonth} from 'utils/date'

const styles = {
	tabFilled: {

		fontSize: "13px"
	},
	tabEmpty: {
		fontSize: "12px",

		fontStyle: "italic",
		opacity: "0.5"
	},
	inputMob: {
		width: "100%",
		marginLeft: "0px"
	},
	inputDesk: {
		width: "250px",
		marginLeft: "0px"
	}
}

let select = dirtyRead(
	(state, props) => {
		return {
			transaction: transactionEx(state, props.transactionId)
		  , parties: tenants(state)
		  , properties: properties(state)
		}
	}
)

export class TransactionCard extends Component {
	render(){
		let isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)
        let inputField = (isMob)?styles.inputMob:styles.inputDesk
		let { props } = this
			let transactionId = this.props.transactionId
			return(
				<Link
					className="vandor-card"
					to={`/manager/transaction/${transactionId}`}
					style={{
						textDecoration: 'none'
					}}
				>
					<ListItem
						style={{
							overflow: 'hidden'
						  , paddingLeft: (typeof global.md.phone() == 'string')?"10px":"0"
						  , marginLeft: (typeof global.md.phone() != 'string')?"0":undefined
						  , margin: "0"
						  , textOverflow: "ellipsis"

						}}
						innerDivStyle={{
							padding: "0 15px"
						}}
						className="list-hover"
					>

						<p style={{width: "100%"}}>
							<p style={{
								fontSize: "16px"
							  , textOverflow: "ellipsis"
							  , whiteSpace: "nowrap"
							  , overflow: "hidden"
							  , margin: "0"
							  , marginRight: "4%"
							  , width: '60%'
							  , float: "left"
							  , display:"inline-block"
							}}>
									{props.transaction.vendor ? `${props.transaction.vendor}`
									: props.transaction.party ? `${props.transaction.party}`
									: props.transaction.partyID && props.parties[props.transaction.partyID]? `${props.parties[props.transaction.partyID].firstName} ${props.parties[props.transaction.partyID].lastName}` : <div style={{width:"100%"}}></div>}
							</p>
							<p style={{
								fontSize: "14px"
							  , textOverflow: "ellipsis"
							  , whiteSpace: "nowrap"
							  , overflow: "hidden"
							  , margin: "0"
							  , width: '15%'
							  , height: "15px"
							  , display:"inline-block"
							  , textAlign:"left"
							}}>

								<span style={{color:((!(props.transaction.isPaid && props.transaction.isPaid.toString()=="true") || (props.transaction.paidAmount && Numeral((props.transaction.amount || (props.transaction.lines && props.transaction.lines[0].amount))) > Numeral(props.transaction.paidAmount))) && (new Date().valueOf() - new Date (props.transaction.dueDate).valueOf())>0)?"red":"black"}}>
									{`${getTimezoneDate(props.transaction.dueDate).getDate()} ${getMonth(getTimezoneDate(props.transaction.dueDate).getMonth())} ${getTimezoneDate(props.transaction.dueDate).getFullYear()%100}`}
								</span>
							</p>
							<p style={{
								  fontSize: "16px"
								, textOverflow: "ellipsis"
								, whiteSpace: "nowrap"
								, overflow: "hidden"
								, margin: "0"
								, fontWeight: "bold"
  							    , marginLeft: "1%"
								, width: '20%'
								, display:"inline-block"
								, color: !(props.transaction.type=='transaction/invoice')?"#FF0000":"green"
								, float:"right"
								, textAlign:"right"
						    }}>
								{(props.transaction.type!='transaction/invoice' && props.transaction.amount)?'-':''}
								{props.transaction.type=='transaction/invoice' ?
									<span style={{fontSize: "14px", fontWeight: "bold", textDecoration: props.transaction.balance>=0?"line-through":"none"}}>
										${(props.transaction.balance >= 0 || props.transaction.balance === -props.transaction.amount)
											?Numeral(props.transaction.amount).format('0,00.')
											:`${Numeral(props.transaction.amount).format('0,00.')}-${Numeral(props.transaction.amount+props.transaction.balance).format('0,00.')}=${Numeral(-props.transaction.balance || 0).format('0,00.')}`}
									</span>
								:<span style={{fontSize: "14px", fontWeight: "bold", textDecoration: ((props.transaction.isPaid && props.transaction.isPaid.toString()=="true") &&
								(props.transaction.amount || (props.transaction.lines && props.transaction.lines[0].amount)))?"line-through":"none"}}>
									{Numeral(props.transaction.amount).format('0,00.')}
								</span>}
							</p>
						</p>
					</ListItem>
				</Link>
			)
	}

}
export default connect(select)(TransactionCard)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/transactions/Card.js